import { useTranslation } from 'react-i18next';

import {
    type AuditFilterChange,
    type AuditLogEntry,
    addAuditFilters,
    describeUserAgent,
    useAuditText,
} from '@/domain/auditLog';

import CellFilterButton from './CellFilterButton';
import CellLines from './CellLines';

interface SourceCellProps {
    entry: AuditLogEntry;
    onFilter: (change: AuditFilterChange) => void;
}

/** Where the request came from: the address, and the client software in a few words. */
export default function SourceCell({ entry, onFilter }: SourceCellProps) {
    const { t } = useTranslation();
    const render = useAuditText();
    const { ip, userAgent } = entry;
    const software = describeUserAgent(userAgent);
    const softwareText = software === null ? null : render(software.text);

    return (
        <CellLines
            numeric
            first={
                ip === null ? (
                    t('auditLog.table.noValue')
                ) : (
                    <CellFilterButton value={ip} onFilter={() => onFilter(addAuditFilters({ ip }))}>
                        {ip}
                    </CellFilterButton>
                )
            }
            firstTitle={ip ?? undefined}
            second={
                software === null || softwareText === null ? null : (
                    <CellFilterButton
                        value={software.filterText}
                        detail={userAgent ?? undefined}
                        onFilter={() =>
                            onFilter(addAuditFilters({ userAgent: software.filterText }))
                        }>
                        {softwareText}
                    </CellFilterButton>
                )
            }
            secondTitle={userAgent ?? undefined}
        />
    );
}
